import { clsx } from 'clsx';

interface LoadingSpinnerProps {
  size?: 'sm' | 'md' | 'lg';
  text?: string;
  fullPage?: boolean;
}

export const LoadingSpinner = ({
  size = 'md',
  text = 'Loading...',
  fullPage = false,
}: LoadingSpinnerProps) => {
  const sizeClasses = {
    sm: 'h-4 w-4',
    md: 'h-8 w-8',
    lg: 'h-12 w-12',
  };

  const spinner = (
    <div className={clsx('flex items-center gap-3', fullPage && 'justify-center')}>
      <svg
        className={clsx('animate-spin text-primary-600 dark:text-primary-400', sizeClasses[size])}
        fill="none"
        viewBox="0 0 24 24"
      >
        <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
        <path
          className="opacity-75"
          fill="currentColor"
          d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
        />
      </svg>
      {text && <span className="text-content-secondary">{text}</span>}
    </div>
  );

  if (fullPage) {
    return (
      <div className="flex h-screen w-full items-center justify-center bg-surface-page">
        {spinner}
      </div>
    );
  }

  return spinner;
};
